<template>
  <vk-modal-body>
    <vk-modal-header>
      Checking Availability for {{ service.display_name }}
    </vk-modal-header>
    <vk-modal-content>
      <transition name="fade" mode="out-in">
        <choose-zipcode
            v-if="!isZipcodeChosen"
            @zipcode-chosen="$emit('zipcode-chosen', $event)"/>
        <choose-city-and-state
            v-else-if="!isCityChosen || !isStateChosen"
            :zipcode="zipcode"
            @location-chosen="$emit('location-chosen', $event)"/>
      </transition>
    </vk-modal-content>
  </vk-modal-body>
</template>

<script>
import ChooseZipcode from './components/ChooseZipcode';
import ChooseCityAndState from './components/ChooseCityAndState';

export default {
  name: 'select-location-modal',
  components: {
    ChooseZipcode,
    ChooseCityAndState,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    isCityChosen: {
      type: Boolean,
      required: true,
    },
    isStateChosen: {
      type: Boolean,
      required: true,
    },
    isZipcodeChosen: {
      type: Boolean,
      required: true,
    },
    zipcode: {
      type: String,
      required: true,
    },
  },
};
</script>
